<div class="photo-container">
  <ng-container *ngIf="imageUrl; else placeholder">
    <img [src]="imageUrl" alt="Image" class="photo-image img-thumbnail" />
  </ng-container>
  <ng-template #placeholder>
    <div class="photo-placeholder">
      <div class="cross">
        <span>Photo à sélectionner</span>
      </div>
    </div>
  </ng-template>
</div>
